<template>
	<div id="mapss">
		<!-- 上 -->
		<div class="mapstop">
			<div class="pub_title" style="width: 13%;height: 100px;float: left;">
				<div class="img_logo" style="margin-top: 47px;">
					<img src="../imges/lebiao/zhhy.png" alt="">
				</div>
				<div class="title_t" style="width: 90px;margin-top: 47px;">
					<div class="imhg_ti">
						<img src="../imges/lebiao/cqdwa.png" alt="">
					</div>
					<div class="sm_t">
						<div style="float:left"><span>船海</span><span style="color:#D7230C;">地图</span></div>
					</div>
				</div>
			</div>
			<div class="maptop_a">
				模糊搜索:
				<div class="maptop_a_a">
					<input v-model="keywords" type="text" placeholder="请输入内容">
					<div @click="selectChild2">
						搜索
					</div>
				</div>
			</div>
			<div class="maptop_a">
				精确搜索:
				<div class="maptop_a_a">
					<input v-model="keyword" type="text" placeholder="请输入内容">
					<div @click="selectChild1">
						搜索
					</div>
				</div>
			</div>
			<div class="maptop_b">
				行业：
				<el-cascader placeholder="搜索：行业" class="eloptionxg" :options="industry" @change="handleAreaChange"
					filterable>
				</el-cascader>
			</div>
			<div class="maptop_b">
				地区：
				<el-cascader placeholder="搜索：地区" class="eloptionxg" :options="cityoptions" @change="handleAreaarea"
					filterable>
				</el-cascader>
			</div>
			<!-- <div class="maptop_c" @click="dnmb">
				点击入驻
			</div> -->
		</div>
		<!-- 中 -->
		<div @click="zkgba" v-show="zkgb"
			style="width: 50px;height: 25px;background-color: #D7230C;color: #FFF;line-height: 25px;text-align: center;z-index: 99999;position: absolute;left: 300px;margin-top: 15px;">
			关闭
		</div>
		<div @click="zkgba" v-show="!zkgb"
			style="width: 50px;height: 25px;background-color: #D7230C;color: #FFF;line-height: 25px;text-align: center;z-index: 99999;position: absolute;left: 300px;margin-top: 15px;">
			展开
		</div>
		<div class="Mapcenter" v-show="zkgb">

			<div class="listUPqy">
				<!-- 企业滚动条 -->
				<el-timeline>
					<el-timeline-item v-for="(activity, index) in activities" :key="index" :type="activity.type"
						:color="activitiesColor" @click.native="gotoxq(activity)">
						{{activity.title}}
					</el-timeline-item>
				</el-timeline>
			</div>
		</div>

		<div class="popContainer" v-if="isShowSQ">
			<!-- 制作 -->
			<div class="sq_ewm">
				<div class="sq_ewm_title">企业VR申请拍摄</div>
				<div class="gb_sqewm" @click="gb_sqzz">
					×
				</div>
				<div class="from_sq">
					<el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign">
						<el-form-item label="单位名称" class="dwmc_warp">
							<el-input v-model="formLabelAlign.dbname"></el-input>
						</el-form-item>
						<el-form-item label="联系人" class="lxr_warp">
							<el-input v-model="formLabelAlign.name"></el-input>
						</el-form-item>
						<el-form-item label="职务" class="zw_warp">
							<el-input v-model="formLabelAlign.zw"></el-input>
						</el-form-item>
						<el-form-item label="手机" class="zw_warp">
							<el-input v-model="formLabelAlign.phone"></el-input>
						</el-form-item>
						<el-form-item label="电话" class="zw_warp">
							<el-input v-model="formLabelAlign.tel"></el-input>
						</el-form-item>
						<el-form-item label="邮箱" class="zw_warp">
							<el-input v-model="formLabelAlign.email"></el-input>
						</el-form-item>
						<el-form-item label="展示选项" class="dwmc_warp">
							<el-checkbox-group v-model="formLabelAlign.zhanshi">
								<el-checkbox label="VR全景展示"></el-checkbox>
								<el-checkbox label="船海地图"></el-checkbox>
							</el-checkbox-group>
						</el-form-item>
						<el-form-item label="添加链接" class="dwmc_warp">
							<el-input v-model="formLabelAlign.link"></el-input>
						</el-form-item>
						<el-form-item style="margin-top:5px;">
							<el-button style="width:180px;font-size:1.1rem;background:red;border:none;" type="primary"
								@click="submitVRsq()">立即申请</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>

		<!-- 下 -->
		<div class="mapsbottom">
			<el-amap vid="amapDemo" :zoom="zoom" :center="center" class="amap-demo">
				<el-amap-marker v-for="(item) in userList" :key="item.id" :position="[item.posix,item.posiy]"
					:events="item.events" :extData="item" :label="{
			      offset:[-10,-25],
			      content: item.title,
			      direction: 'bottom',
			  }"></el-amap-marker>

				<!-- 信息窗体 -->
				<el-amap-info-window v-if="window" :position="[window.posix,window.posiy]" :visible="window.visible"
					:content="window.xxct" :offset=[0,-36]>
					<div class="vrmap_s_warp">
						<div class="map_title">
							<div class="map_img">
								<img src="../imges/map/map01.png" alt="">
							</div>
							<div class="map_name">{{window.title}}</div>
						</div>
						<!-- <div class="map_title" v-show="window.title == this.keyword">
							<div class="map_img">
								<img src="../imges/map/map01.png" alt="">
							</div>
							<div class="map_name">1</div>
						</div> -->
						<div class="logo_x">
							<!-- logo -->
							<!-- d判断认证 -->
							<img :src=" 'https://admin.shipoe360.com/public/' + window.ggcontent " alt=""
								@click="tzdgg(window.gglink)">
						</div>
						<div class="ms_ms">{{window.zy}}</div>
						<div class="qy_lxr_warp">
							<div class="qy_lxr" @click="wdnmlgblxr(window.lxr)" style="margin-left: 1%;">
								<div class="qy_lxr_img">
									<img src="../imges/map/fzr.png" alt="">
								</div>
							</div>
							<div class="dh_gt_p" @click="djhmasb('座机号:'+window.phone+'手机号:'+window.mbphone)">
								<div class="dh_p_img">
									<img src="../imges/map/dhlx.png" alt="">
								</div>
							</div>
							<div class="dh_gt_p" @click="yyqt">
								<div class="dh_p_img">
									<img src="../imges/map/hzqt.png" alt="">
								</div>
								<!-- <div class="text_pi">预约洽谈</div> -->
							</div>
							<div class="dh_gt_p" @click="sqrz(window)">
								<div class="text_pi">申请认证</div>
							</div>
						</div>
						<div class="qy_lxr_warp1">
							<div class="qy_lxr" style="margin-left: 0%;" @click="qiye(window.guanlink)">
								<div class="qy_lxr_img">
									<img src="../imges/map/x01.png" alt="">
								</div>
								<div class="qy_lxr_title_">企业</div>
							</div>
							<div class="qy_lxr qy_lxr1" @click="shangcheng(window.shoplink)">
								<div class="qy_lxr_img">
									<img src="../imges/map/x02.png" alt="">
								</div>
								<div class="qy_lxr_title_">商城</div>
							</div>
							<div class="qy_lxr qy_lxr1" @click="dakai(window.vrlink)">
								<div class="qy_lxr_img">
									<img src="../imges/map/x03.png" alt="">
								</div>
								<div class="qy_lxr_title_">VR</div>
							</div>
							<div class="qy_lxr qy_lxr1">
								<div class="qy_lxr_img" @click="weizhi(window.area,window.address,window.youbian)">
									<img src="../imges/map/x04.png" alt="">
								</div>
								<div class="qy_lxr_title_">位置</div>
							</div>
							<div class="qy_lxr qy_lxr1" @click="gda(window)">
								<div class="qy_lxr_img">
									<img src="../imges/map/x05.png" alt="">
								</div>
								<div class="qy_lxr_title_">周边</div>
							</div>
						</div>
					</div>

				</el-amap-info-window>
			</el-amap>


			<el-dialog title="申请认证" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
				<el-form ref="form" :model="qbesss" label-width="80px">
					<el-form-item label="公司名称">
						<el-input v-model="qbesss.dbname"></el-input>
					</el-form-item>
					<el-form-item label="姓名">
						<el-input v-model="qbesss.name"></el-input>
					</el-form-item>
					<el-form-item label="职务">
						<el-input v-model="qbesss.zw"></el-input>
					</el-form-item>
					<el-form-item label="联系电话">
						<el-input v-model="qbesss.phone"></el-input>
					</el-form-item>
					 <el-form-item>
					    <el-button type="primary" @click="onSubmit">立即创建</el-button>
					  </el-form-item>
				</el-form>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	import cityoptions from '../utils/city.js'
	export default {
		data() {
			return {
				isShowSQ: false,
				industry: [],
				cityoptions: [],
				diqua: '',
				dialogVisible: false,
				sqaaa: '',
				labelPosition: 'left',
				hya: '',
				qbesss: {
					dbname: '',
					name: '',
					zw: '',
					phone: '',
				},
				zoom: 4,
				center: [106.5273285, 36.21515044],
				userList: '',
				window: '',
				keyword: '',
				keywords: '',
				activities: [],
				zkgb: true,
				activitiesColor: '#DC0500',
				formLabelAlign: {
					uid: 0,
					unitName: '', //单位名称
					contacts: '', //联系人
					userPost: '', //职务
					phone: '', //手机号
					telephone: '', //电话
					email: '', //邮箱
					zhanshi: [],
					linkAddress: '', //添加链接
					VRZT: true, //vr展厅
					VRDT: true //vr地图
				},
			}
		},
		methods: {
			zkgba() {
				this.zkgb = !this.zkgb
			},
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},
			async gda(ids) {
				let newList = []
				console.log(ids)
				let res = await http.get('api/picture/chdt_gd', {
					id: ids.id
				})
				console.log(res)
				let self = this
				res.data.data.list.forEach((item, index) => {
					if (item.posix == '' || item.posiy == '' || item.posix == null || item.posiy ==
						null) {} else {
						item.visible = false
						item.events = {
							click() {
								self.window = item
								self.$nextTick(() => {
									self.window.visible = true;
								});
							}
						}
						// end
						newList.push(item)
					}
					if (!item.jc) {
						item.jc = item.title
					}
				})
				self.center = []
				// self.center[0] = res.data.data.list[0].posix
				self.center[0] = res.data.data.list[0].posix
				// self.center[1] = res.data.data.list[0].posiy
				self.center[1] = res.data.data.list[0].posiy
				this.userList = newList
				console.log(this.userList)
				selt.zoom = 12
			},
			async handleAreaChange(val) {
				let that = this
				that.hya = val[1]
				let newList = []
				let res = await http.post('api/common/index', {
					model: 'qydb',
					type: 'content',
					mid: '4',
					fid: this.hya,
					area: this.diqua,
					rows_limit: '999'
				})
				console.log(res)
				res.data.data.list.data.forEach((item, index) => {
					if (item.posix == '' || item.posiy == '' || item.posix == null || item.posiy ==
						null) {} else {
						item.visible = false
						item.events = {
							click() {
								that.window = item
								that.$nextTick(() => {
									that.window.visible = true;
								});
							}
						}
						newList.push(item)
					}
				})
				that.userList = newList
				that.zoom = 4
				that.center = [106.5273285, 36.21515044]
			},
			async handleAreaarea(val) {
				let that = this
				that.diqua = val[0]
				let newList = []
				let res = await http.post('api/common/index', {
					model: 'qydb',
					type: 'content',
					mid: '4',
					fid: this.hya,
					area: this.diqua,
					rows_limit: '999'
				})
				res.data.data.list.data.forEach((item, index) => {
					if (item.posix == '' || item.posiy == '' || item.posix == null || item.posiy ==
						null) {} else {
						item.visible = false
						item.events = {
							click() {
								that.window = item
								that.$nextTick(() => {
									that.window.visible = true;
								});
							}
						}
						newList.push(item)
					}
				})
				that.userList = newList
				that.zoom = 4
				that.center = [106.5273285, 36.21515044]
			},
			async submitVRsq() {
				let that = this;
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (!loginInfo) {
					that.$alert('请登录', '提示', {
						confirmButtonText: '确定',
					});
					return false;
				}
				this.formLabelAlign.uid = String(loginInfo.id)
				this.$axios({
					url: 'https://admin.shipoe360.com/api/picture/vrzs',
					method: "post",
					params: this.formLabelAlign
				}).then(res => {
					that.$alert(res.data.msg, '提示', {
						confirmButtonText: '确定',
					});
					this.isShowSQ = false
				})
			},
			async selectChild2() {
				console.log(this.keywords)
				let self = this
				let newList = []
				if (this.keywords != '') {
					// let res = await http.post('api/Common/index', {
					let res = await http.get('api/picture/chdt_cs', {
						name: this.keywords,
					})
					console.log(res)
					if (res.data.data.length == 0) {
						alert('没有该船企')
						return
					}
					let selt = this
					// res.data.data.list.data.forEach((item, index) => {
					res.data.data.list.forEach((item, index) => {
						if (item.posix == '' || item.posiy == '' || item.posix == null || item.posiy ==
							null) {} else {
							item.visible = false
							item.events = {
								click() {
									self.window = item
									self.$nextTick(() => {
										self.window.visible = true;
									});
								}
							}
							// end
							newList.push(item)
						}
						if (!item.jc) {
							item.jc = item.title
						}
					})
					// 
					
					self.center = []
					self.center[0] = res.data.data.list[0].posix
					// self.center[0] = res.data.data.list.data[0].posix
					self.center[1] = res.data.data.list[0].posiy
					// self.center[1] = res.data.data.list.data[0].posiy
					this.userList = newList
					selt.zoom = 8
					selt.$nextTick(()=> {
						setTimeout(() => {
							console.log($(".amap-markers .amap-marker"), '$(".amap-marker")')
							$(".amap-markers .amap-marker").removeClass("amap-marker-animation").addClass("amap-marker-animation")
						})
						// $(".amap-markers").attr("'class", "amap-marker").addClass("amap-marker-animation")
						// $(".amap-marker").removeClass("amap-marker-animation").addClass("amap-marker-animation")
					})
				} else {
					alert('请输入内容！')
				}
			},
			async selectChild1() {
				console.log(this.keyword)
				let self = this
				let newList = []
				if (this.keyword != '') {
					// let res = await http.post('api/Common/index', {
					let res = await http.post('api/Common/index', {
						model: 'qydb',
						type: 'content',
						mid: '4',
						title: this.keyword,
						rows_limit: '999'
					})
					console.log(res)
					if (res.data.data.list.data.length == 0) {
						alert('没有该船企')
						return
					}
					let selt = this
					res.data.data.list.data.forEach((item, index) => {
						// res.data.data.list.forEach((item, index) => {
						if (item.posix == '' || item.posiy == '' || item.posix == null || item.posiy ==
							null) {} else {
							item.visible = false
							item.events = {
								click() {
									self.window = item
									self.$nextTick(() => {
										self.window.visible = true;
									});
								}
							}
							// end
							newList.push(item)
						}
						if (!item.jc) {
							item.jc = item.title
						}
					})
					self.center = []
					// self.center[0] = res.data.data.list[0].posix
					self.center[0] = res.data.data.list.data[0].posix
					// self.center[1] = res.data.data.list[0].posiy
					self.center[1] = res.data.data.list.data[0].posiy
					this.userList = newList
					console.log(this.userList)
					selt.zoom = 8
				} else {
					alert('请输入内容！')
				}
			},
			async gotomap() {
				this.hya = 360
				let selt = this
				let newList = []
				let res1 = await http.post('api/common/index', {
					model: 'qydb',
					type: 'content',
					mid: '4',
					fid: this.hya,
					area: this.diqua,
					rows_limit: '99'
				})

				res1.data.data.list.data.forEach((item, index) => {
					if (item.posix == '' || item.posiy == '' || item.posix == null || item.posiy ==
						null) {} else {
						item.visible = false
						item.events = {
							click() {
								selt.window = item
								selt.$nextTick(() => {
									selt.window.visible = true;
								});
							}
						}
						newList.push(item)
					}
				})
				selt.userList = newList
				selt.zoom = 4
				selt.center = [106.5273285, 36.21515044]
			},
			tzdgg(val) {
				window.open(val)
			},
			gotoxq(activity) {
				this.$router.push({
					path: '/qydqdetail',
					query: {
						id: activity.id,
						title: activity.title
					}
				})
			},
			qiye(id) {
				window.open(id)
			},
			gb_sqzz() {
				this.isShowSQ = !this.isShowSQ
			},
			dakai(id) {
				window.open(id);
			},
			weizhi(x, y, z) {
				this.$alert(x + '   ' + y + '  ' + z, '地址', {
					confirmButtonText: '确定',
				});
			},
			wdnmlgblxr(id) {
				this.$alert(id, '联系人', {
					confirmButtonText: '确定',
				});
			},
			dnmb() {
				this.isShowSQ = true
			},
			djhmasb(id) {
				this.$alert(id, '联系方式', {
					confirmButtonText: '确定',
				});
			},
			sqrz(id) {
				console.log(id)
				this.dialogVisible = true
				this.sqaaa = id
			},
			async onSubmit(){
				
				if(this.qbesss.dbname==''){
					alert('请填写完整')
					return
				}
				
				if(this.qbesss.name==''){
					alert('请填写完整')
					return
				}
				
				if(this.qbesss.zw==''){
					alert('请填写完整')
					return
				}
				
				if(this.qbesss.phone==''){
					alert('请填写完整')
					return
				}
				
				let res = await http.post('api/picture/ship_positioning_offer',{
					dbname:this.qbesss.dbname,
					name:this.qbesss.name,
					zw:this.qbesss.zw,
					phone:this.qbesss.phone,
				})
				console.log(res)
				if(res.data.code==200){
					this.$message({
						type: 'success',
						message: '申请成功'
					});
					this.dialogVisible = false
				} else {
					this.$message({
						type: 'error',
						message: '申请失败'
					});
				}
			},
			yyqt() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (!loginInfo) {
					this.$message.error('请返回首页重新登陆');
					return false;
				}

				this.$prompt('请输入您的留言', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				}).then(({
					value
				}) => {
					// console.log(value)
					//  alert(value)
					var data = {
						fid: 2,
						uid: loginInfo.id,
						linkman: value,
						telphone: value,
						content: this.window.title
					}
					this.$axios({
						url: 'https://admin.shipoe360.com/index.php/p/guestbook-wxapp.post-add.html',
						method: "post",
						params: data
					}).then(res => {
						this.$message({
							type: 'success',
							message: res.data.msg
						});
					})

				}).catch(() => {

					this.$message({
						type: 'info',
						message: '取消输入'
					});
				});
			},
		},
		async mounted() {
			this.cityoptions = cityoptions
			let res = await http.get('api/qydb/index')
			let batchdata = res.data.data
			let dataValueBatch = batchdata => batchdata.map(({
				id,
				name,
				child_1
			}) => (child_1 ? {
				value: id,
				label: name,
				children: dataValueBatch(child_1)
			} : {
				value: id,
				label: name
			}))
			this.industry = dataValueBatch(batchdata)

			let res1 = await http.get('api/picture/getQYA')
			this.activities = res1.data.data
		},
		async created() {
			this.gotomap()
		}
	}
</script>

<style>
	#mapss {
		width: 100%;
		height: 600px;
		box-shadow: 10px 20px 10px -15px rgb(231, 231, 231);
		position: relative;
	}


	.mapstop {
		width: 100%;
		height: 85px;
	}

	.maptop_a {
		padding-top: 22px;
		width: 25%;
		height: 50px;
		float: left;
		line-height: 90px;
		font-size: 20px;
		font-weight: 800;
		margin-left: 20px;
	}

	.maptop_a_a {
		width: 70%;
		margin-top: 25px;
		height: 40px;
		float: right;
		box-sizing: border-box;
		border: 3px solid #D7230C;
		background: #D7230C;
	}

	.maptop_a_a>input {
		width: 65%;
		height: 32px;
		float: left;
		border: 0px;
		outline: none;
	}

	.maptop_a_a>div {
		width: 25%;
		height: 34px;
		float: left;
		background-color: #D7230C;
		line-height: 34px;
		text-align: center;
		color: #fff;
		cursor: pointer;
	}

	.maptop_b {
		width: 16%;
		height: 50px;
		line-height: 50px;
		margin-top: 40px;
		margin-left: 10px;
		float: left;
		font-weight: 800;
		font-size: 20px;
	}

	.maptop_c {
		width: 10%;
		height: 50px;
		line-height: 50px;
		text-align: center;
		background-color: #D7230C;
		margin-left: 10px;
		margin-top: 25px;
		float: left;
		box-sizing: border-box;
		font-size: 20px;
		color: #FFF;
		font-weight: 800;
	}

	.eloptionxg {
		width: 120px;
	}

	.mapsbottom {
		height: 500px;
		width: 100%;
		overflow: hidden;
	}

	.map_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.map_title {
		height: 40px;
	}

	.map_img {
		float: left;
		width: 40px;
		height: 40px;
		margin-left: 10px
	}

	.map_name {
		float: left;
		height: 40px;
		margin-left: 10px;
		width: calc(100% - 70px);
		line-height: 40px;
		font-size: 18px;
		font-weight: 600;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.logo_x {
		width: 96%;
		margin: 10px auto;
		height: 85px;
		padding: 2px;
		border: 1px solid #ddd;
	}

	.ms_ms {
		width: 92%;
		margin: 20px auto;
		font-size: 14px;
		color: #686767;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.qy_lxr1 {
		margin-left: 10px !important;
	}

	.qy_lxr {
		float: left;
		margin-left: 14px;
	}

	.qy_lxr_img {
		float: left;
		cursor: pointer;
		margin-left: 6px;
		width: 28px;
		height: 28px;
	}

	.qy_lxr_title {
		float: left;
		cursor: pointer;
		margin-top: 4px;
		font-size: 13px;
	}

	.qy_lxr_title_ {
		cursor: pointer;
		width: 30px;
		margin-left: 6px;
		text-align: center;
		margin-top: 4px;
		font-size: 14px;
	}

	.dh_gt_p {
		float: left;
		margin-left: 16px;
	}

	.dh_p_img {
		float: left;
		height: 28px;
		width: 28px;
	}

	.text_pi {
		float: left;
		height: 28px;
		line-height: 28px;
		margin-left: 6px;
		color: #000;
	}

	.qy_lxr_warp1 {
		margin-top: 15px;
		height: 50px;
		width: 99%;
		border: 1px solid #ddd;
	}

	.map_img>img {
		width: 100%;
		height: 100%;
	}

	.qy_lxr_img>img {
		width: 100%;
		height: 100%;
	}

	.dh_gt_p>img {
		width: 100%;
		height: 100%;
	}

	#amapDemo /deep/ .el-vue-amap {
		height: 105%;
	}

	.logo_x>img {
		width: 100%;
		height: 100%;
	}

	.dh_p_img>img {
		width: 100%;
		height: 100%;
	}

	.qy_lxr_warp {
		height: 30px;
	}

	.Mapcenter {
		width: 300px;
		height: 500px;
		background: #000;
		position: absolute;
		left: 0px;
		z-index: 99;
		margin-top: 15px;
		background-color: rgba(0, 0, 0, 0.5);
		overflow: hidden;
	}

	.listUPqy:hover {
		animation-play-state: paused;
	}

	.Mapcenter /deep/ .el-timeline-item__content {
		color: #fff;
		font-size: 15px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		cursor: pointer;

	}

	@keyframes Mapcenter {
		0% {
			-webkit-transform: translate3d(0, 0, 0);
			transform: translate3d(0, 0, 0);
		}

		100% {
			-webkit-transform: translate3d(0, -1000px, 0);
			transform: translate3d(0, -1000px, 0);
			display: none;
		}
	}

	.listUPqy {
		width: 96%;
		-webkit-animation: Mapcenter 40s linear infinite normal;
		animation: Mapcenter 40s linear infinite normal;
	}

	.popContainer {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999;
		background: rgba(0, 0, 0, 0.6);
	}

	.sq_ewm {
		position: absolute;
		top: 30%;
		left: 35%;
		/* margin-left: -250px;
		margin-top: -300px; */
		width: 500px;
		background-color: #fff;
		border-radius: 10px;
		overflow: hidden;
		z-index: 9999;
	}


	.sq_ewm .sq_ewm_title {
		height: 60px;
		background-color: #e90e0e;
		color: #fff;
		text-align: center;
		line-height: 60px;
		font-size: 20px;
		letter-spacing: 6px;
	}

	.sq_ewm .gb_sqewm {
		position: absolute;
		top: 10px;
		right: 10px;
		cursor: pointer;
		width: 20px;
		height: 20px;
	}

	#amapDemo {
		width: 100%;
		height: 105%;
	}

	.sq_ewm .from_sq {
		width: 80%;
		margin: 10px auto;
	}

	/deep/ .el-form-item__label {
		font-size: 16px;
	}

	.from_sq /deep/ .el-form-item {
		margin-bottom: 5px;
	}

	/deep/ .dwmc_warp label {
		letter-spacing: 4px;
	}

	/deep/ .zw_warp {
		letter-spacing: 30px;
	}

	/deep/ .lxr_warp {
		letter-spacing: 14px;
	}

	/deep/ .search_sty_input input {
		border: #ca151e 2px solid;
		height: 40px;
		line-height: 40px;
		border-right: none;
	}


	.img_left_top {
		height: 120px;
		width: 100%;
		overflow: hidden;
	}

	.img_left_top>img {
		width: 100%;
		display: table-cell;
		text-align: center;
		vertical-align: middle;
		height: 100%;
	}

	._left_text {
		line-height: 25px;
		text-align: center;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		font-size: 14px;
		position: absolute;
		background: #999999;
		width: 30%;
		color: #fff;
		height: 25px;
		font-size: 12px;
		border-radius: 0px 0px 8px 8px;
	}


.amap-marker-animation:before{   
content:' ';   
position: absolute;   
z-index:2;   
left:4px;   
top:30px;   
width:10px;   
height:10px;   
opacity: 0;
background-color: #729bdf;   
border-radius: 50%;   
}   
  
.amap-marker-animation:after {   
content:' ';   
position: absolute;   
z-index:1;   
left:6px;   
top:26px; 
width:10px;   
height:10px;   
background-color: #648dcf;   
border-radius: 50%;   
box-shadow: 0 0 10px rgba(0,0,0,.3) inset;   
-webkit-animation-name:'ripple';/*动画属性名，也就是我们前面keyframes定义的动画名*/  
-webkit-animation-duration: 1.8s;/*动画持续时间*/  
-webkit-animation-timing-function: ease; /*动画频率，和transition-timing-function是一样的*/  
-webkit-animation-delay: 0s;/*动画延迟时间*/  
-webkit-animation-iteration-count: infinite;/*定义循环资料，infinite为无限次*/  
-webkit-animation-direction: normal;/*定义动画方式*/  
}  

@keyframes ripple {   
0% {   
opcity:75;   
width:5px;   
height:5px;   
}   
100% {   
/* left:-20px;   
top:-20px;    */
opacity: 0;   
transform: scale(8);
}   
}  
</style>
